import { motion } from "framer-motion";
import { useState } from "react";
function App() {
  const [showCard, setShowCard] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // height: "100vh",
        background: "white",
      }}
    >
      <motion.div
        style={{
          background: "#fff",
          padding: "3rem 2rem",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        }}
        //hover
        whileHover={{
          scale: 1.1,
          boxShadow: "0 0 10px rgba(0,0,0,0.4)",
        }}
        transition={{
          layout: {
            duration: 1,
            type: "spring",
          },
        }}
        layout
        onClick={() => setShowCard(!showCard)}
      >
        <motion.h4 layout="position">Hover or click</motion.h4>
        {showCard && (
          <motion.p
            style={{ width: "600px" }}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
            }}
          >
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum
            error reiciendis iure architecto qui magni, excepturi voluptatum
            repudiandae nihil rerum eveniet pariatur ipsa velit similique et
            aliquam, deserunt totam explicabo.
          </motion.p>
        )}
      </motion.div>
    </div>
  );
}
export default App;